import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../BuiltinInstanceMemberCall';
export class ArrayEntries extends BuiltinInstanceMemberCall {
    canCall() {
        return true;
    }
    emitCall(sb, func, node, options, visited) {
        if (!options.pushValue) {
            if (visited) {
                sb.emitOp(node, 'DROP');
            }
            return;
        }
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitHelper(node, options, sb.helpers.createIteratorIterableIterator({
            mapKey: (innerOptions) => {
                sb.emitHelper(node, innerOptions, sb.helpers.wrapNumber);
            },
        }));
    }
}

//# sourceMappingURL=entries.js.map
